import { Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../cssfiles/homepage.css";
import CustomTableHeading from '../CommonComponents/CustomTableHeading';
import CustomTableMetric from '../CommonComponents/CustomTableMetric';
import CustomActionButton from "../CommonComponents/CustomActionButton";
import LKLogo from '../../images/LKLogo.svg';
import AdaniLogo from '../../images/PlantLogo.png';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CustomButton from "../CommonComponents/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import {deleteorganization, deleteproject} from "../../Restclient/datacollection";
import {setOrganizationtree} from "../../store/cofig_data";

export default function OrganisationSetting(props) {
    const dispatch = useDispatch()
    const organizationtree = useSelector((state) => state.configdata.organizationdatatree)
    const theme = useSelector((state) => state.themedata.theme)

    const [tabledata, setTabledata] = useState()
    const [orglist, setOrglist] = useState([])
    const [conformdialog, setConformdialog] = useState(false)
    const [deleteorgname, setDeleteorgname] = useState("")
    const [deletprojname, setDeleteprojname] = useState("")

    
    useEffect(() => {
       
        if (!organizationtree || typeof organizationtree !== "object") return;

        if(props.treeselect.hasOwnProperty('type')) {
            if(props.treeselect.type === 'none') {
                var orgli = []
                if(organizationtree.hasOwnProperty('children')) {
                    for(let i=0; i<organizationtree.children.length; i++) {
                        var orgdata = organizationtree.children[i].data;
                        if (!orgdata) continue;
                        orgli.push({
                            logo:  orgdata.Logo.base64,
                            logoheight: orgdata.Logo.height,
                            logowidth: orgdata.Logo.width,
                            name: orgdata.Organizationname,
                            state:  orgdata?.Oranizationdetails?.State,
                            city: orgdata?.Oranizationdetails?.Location,
                            link: orgdata?.Organizationlink,
                            country: orgdata?.Oranizationdetails?.Country,
                            place: orgdata?.Oranizationdetails?.Location,
                            pin: orgdata?.Oranizationdetails?.Pin,
                            region: orgdata?.Projectdetails?.Region,
                            type: organizationtree?.children[i]?.type,
                            latitude: orgdata?.Oranizationdetails?.Latitude,
                            longitude: orgdata?.Oranizationdetails?.Longitude
                        })
                    }
                    setOrglist(orgli)
                }
            } else if(props.treeselect.type === 'Organization') {
                var orgli = []
                for(let i=0; i<props.treeselect.children.length; i++) {
                    var orgdata = props.treeselect.children[i].data
                    orgli.push({
                        logo:  orgdata.Logo.base64,
                        logoheight: orgdata.Logo.height,
                        logowidth: orgdata.Logo.width,
                        name: orgdata.Projectname,
                        state:  orgdata.Projectdetails.State,
                        city: orgdata.Projectdetails.Location,
                        country: orgdata.Projectdetails.Country,
                        place: orgdata.Projectdetails.Location,
                        pin: orgdata.Projectdetails.Pin,
                        region: orgdata.Projectdetails.Region,
                        type: props.treeselect.children[i].type,
                        latitude: orgdata.Projectdetails.Latitude,
                        longitude: orgdata.Projectdetails.Longitude,
                        orgname: props.treeselect.children[i].orgname
                    })
                }
                setOrglist(orgli)
            } else if(props.treeselect.type === 'Project') {
                
            }
        }
    },[props.treeselect])

    const handleeditclick = (org) => {
        props.callbackedit(org)
    }

    const handledeleteclick = (org) => {
        if(props.treeselect.type === 'none') {
            setDeleteorgname(org.name)
            setConformdialog(true)
        } else if(props.treeselect.type === 'Organization') {
            setDeleteorgname(org.orgname)
            setDeleteprojname(org.name)
            setConformdialog(true)
        }
        
    }

    const callbackdeleteorg = (res) => {
        if(res.status === "done") {
            dispatch(setOrganizationtree(res.data.treejson))
        } else {

        }
    } 

    const handledeletdialog = () => {
        if(props.treeselect.type === 'none') {
            deleteorganization(deleteorgname, callbackdeleteorg)
        } else if(props.treeselect.type === 'Organization') {
            deleteproject(deleteorgname,deletprojname,callbackdeleteorg)
        }
        setConformdialog(false)
    }

    const handleClosedialog = () => {
        setConformdialog(false)
    }
    return (
        <div style={{  width: '100%'}}>
            {
                props.treeselect.type === 'none' ?
                <table width={'100%'} align='left' className='scope1-config-table' style={{ margin: '0 0 20px 0', padding: '0', borderSpacing: 0, borderCollapse: 'collapse', overflow: 'auto' }}>
                    {/*<thead style={{position: 'sticky', top: 0, zIndex: 1}}>*/}
                        <tr className='scope1-config-table-heading'>
                            <td>
                                <CustomTableHeading children={'Logo'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'Organisation Name'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'State'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'City'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'Web Link'} />
                            </td>
                            <td colSpan={2}>
                                <CustomTableHeading children={'Actions'} />
                            </td>
                        </tr>
                    {/*</thead>*/}
                    {
                        orglist.map((orgdata) => {
                            return(
                                <tr>
                                    <td>
                                        <div style={{marginLeft: '0px',height: '30px', width: '30px', border: '2px solid', borderColor: '#008CD7', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <img src={orgdata.logo} alt="AdaniLogo" style={{height:`${orgdata.logoheight-55}px`,width:`${orgdata.logowidth-45}px`,marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                        </div>
                                    </td>
                                    <td>
                                        <CustomTableMetric children={orgdata.name} />
                                    </td>
                                    <td>
                                        <CustomTableMetric children={orgdata.state} />
                                    </td>
                                    <td>
                                        <CustomTableMetric children={orgdata.city} />
                                    </td>
                                    <td>
                                        <CustomTableMetric children={orgdata.link} />
                                    </td>
                                    <td align="left">
                                        <span onClick={() => handleeditclick(orgdata)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer', pointerEvents: props.addtrigger ? 'none': 'auto'}} > Edit </span>
                                    </td>
                                    <td align="left">
                                        <span onClick={() => handledeleteclick(orgdata)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer',pointerEvents: props.addtrigger ? 'none': 'auto' }}> Delete </span>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    
                </table>
                :
                <table width={'100%'} align='left' className='scope1-config-table' style={{ margin: '0 0 20px 0', padding: '0', borderSpacing: 0, borderCollapse: 'collapse', overflow: 'auto' }}>
                    <tr className='scope1-config-table-heading'>
                        <td>
                            <CustomTableHeading children={'Logo'} />
                        </td>
                        <td>
                            <CustomTableHeading children={'Project Name'} />
                        </td>
                        <td>
                            <CustomTableHeading children={'State'} />
                        </td>
                        <td>
                            <CustomTableHeading children={'City'} />
                        </td>
                        <td colSpan={2}>
                            <CustomTableHeading children={'Actions'} />
                        </td>
                    </tr>
                    {
                        orglist.map((projdata) => {
                            return(
                                <tr>
                                    <td>
                                        <div style={{marginLeft: '0px',height: '30px', width: '30px', border: '2px solid', borderColor: '#008CD7', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <img src={projdata.logo} alt="AdaniLogo" style={{height:`${projdata.logoheight-55}px`,width:`${projdata.logowidth-45}px`,marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                        </div>
                                    </td>
                                    <td>
                                        <CustomTableMetric children={projdata.name} />
                                    </td>
                                    <td>
                                        <CustomTableMetric children={projdata.state} />
                                    </td>
                                    <td>
                                        <CustomTableMetric children={projdata.city} />
                                    </td>
                                    <td align="left">
                                        <span onClick={() => handleeditclick(projdata)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer', pointerEvents: props.addtrigger ? 'none': 'auto'}} > Edit </span>
                                    </td>
                                    <td align="left">
                                        <span onClick={() => handledeleteclick(projdata)} style={{ fontSize: '12px', fontWeight: 400, color: 'var(--HighlightedText_Stroke)', fontFamily: 'Roboto', textAlign: 'left', cursor: 'pointer',pointerEvents: props.addtrigger ? 'none': 'auto' }}> Delete </span>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    
                </table>
            }
            <Dialog
                open={conformdialog}
                onClose={handleClosedialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: "0px" } }}
            >
                <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {"Conformation Info"}
                </DialogTitle>
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    Do you want to delete {deleteorgname} {props.treeselect.type === 'Organization' ? "project" : "organization"} ?
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor:theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleClosedialog}
                    >
                        Close
                    </button>
                    <button 
                        style={{
                            padding: '8px 20px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: '#005C8E',
                            color: '#FFFFFF',
                            //padding: '8px 45px',
                            border: 'none',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                        }}
                        onClick={handledeletdialog}
                    >
                        Delete
                    </button>
                </DialogActions>
            </Dialog>

        </div>
    )
}